export type Theme = 'dark' | 'light' | 'system'

export const THEME_COOKIE_KEY = 'theme'
export const THEME_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365

export const DEFAULT_THEME: Theme = 'system'

export function isTheme(value: unknown): value is Theme {
	return value === 'dark' || value === 'light' || value === 'system'
}

export function getInitialTheme(): Theme {
	if (typeof window === 'undefined') {
		return DEFAULT_THEME
	}

	const cookie = getCookieValue(document.cookie, THEME_COOKIE_KEY)
	return isTheme(cookie) ? cookie : DEFAULT_THEME
}

export function detectThemeFromRequest(request: Request): Theme | undefined {
	const value = getCookieValue(
		request.headers.get('cookie'),
		THEME_COOKIE_KEY
	)
	return isTheme(value) ? value : undefined
}

export function persistThemeCookie(theme: Theme) {
	if (typeof document === 'undefined') {
		return
	}

	const attributes = [
		`${THEME_COOKIE_KEY}=${encodeURIComponent(theme)}`,
		'path=/',
		`max-age=${THEME_COOKIE_MAX_AGE_SECONDS}`,
		'samesite=lax'
	]

	// biome-ignore lint/suspicious/noDocumentCookie: Cookie Store API is unsupported in Firefox/Safari.
	document.cookie = attributes.join('; ')
}

function getCookieValue(cookieHeader: string | null, key: string) {
	if (!cookieHeader) {
		return
	}

	for (const cookie of cookieHeader.split(';')) {
		const [cookieKey, ...valueParts] = cookie.trim().split('=')
		if (cookieKey === key) {
			try {
				return decodeURIComponent(valueParts.join('='))
			} catch {
				return
			}
		}
	}
}
